import React from 'react';
import { cx } from './utils';

const Modal = ({ open, onClose, title, children, actions, className = '', bodyClassName = '' }) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 px-4 py-6"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div
        className={cx(
          'w-full max-w-2xl rounded-3xl bg-white p-6 shadow-[0_30px_70px_rgba(15,23,42,0.35)]',
          className
        )}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex items-center justify-between gap-3">
          {title && <h3 className="text-lg font-semibold text-slate-900">{title}</h3>}
          <button
            type="button"
            onClick={onClose}
            className="rounded-full border border-slate-200 px-3 py-1.5 text-xs font-semibold text-slate-600"
          >
            Close
          </button>
        </div>
        <div className={cx('mt-4', bodyClassName)}>{children}</div>
        {actions ? <div className="mt-5 flex justify-end gap-3">{actions}</div> : null}
      </div>
    </div>
  );
};

export default Modal;
